import { UserRole } from './user.types';

/**
 * Nivel de urgencia / criticidad de una notificación in-app (ISSUE-83).
 * Enum de STRINGS sin acento a propósito: el valor se usa como valor de un
 * enum de Postgres (`notifications_urgency_enum`) y como parámetro de query —
 * el label con acento ("Crítica") vive sólo en la UI vía
 * `NOTIFICATION_URGENCY_LABELS`. Orden ascendente por severidad.
 */
export enum NotificationUrgency {
  BAJA = 'baja',
  MEDIA = 'media',
  ALTA = 'alta',
  CRITICA = 'critica',
}

export const NOTIFICATION_URGENCY_LABELS: Record<NotificationUrgency, string> = {
  [NotificationUrgency.BAJA]: 'Baja',
  [NotificationUrgency.MEDIA]: 'Media',
  [NotificationUrgency.ALTA]: 'Alta',
  [NotificationUrgency.CRITICA]: 'Crítica',
};

/**
 * Roles habilitados a filtar la bandeja de notificaciones por usuario
 * destinatario (`GET /api/notifications?userId=`). Es una allow-list explícita
 * —no un chequeo por nivel— porque el nivel 2 incluye también
 * `compras_logistica` y `supervision`, y el pedido de ISSUE-83 acota este
 * filtro a roles de conducción. Ampliar acá si Producto lo decide.
 */
export const NOTIFICATION_RECIPIENT_FILTER_ROLES: readonly UserRole[] = [
  UserRole.GERENCIA,
  UserRole.ADMINISTRACION,
];
